export const MAX_VISIBLE_DISABLED_REASONS = 3;

export const DisabledReasonTitle = {
  LOCK_PENDING: 'Lock request is being processed by Optimal Blue',
  PROGRAM_CHANGE_NOT_ALLOWED: 'Optimal Blue will not accept changes to this locked loan',
  UPDATE_REQUEST_PENDING: 'A change request is awaiting a response from Optimal Blue',
  NO_SAVE_ACCESS: 'You do not have access to save these changes',
  NO_OWN_CHANGES: 'You have no pending changes of your own to save',
};

export const DisabledReasonHint = {
  OPTIMAL_BLUE_ADMIN: 'Contact your Optimal Blue administrator.',
  NO_SAVE_ACCESS: 'You do not have access to save them.',
};

export const PENDING_CHANGES_AUTHORS_TITLE_PREFIX = 'Pending changes by';

export const HIDDEN_REASONS_SUFFIX = 'more';

export const OtherAuthorsLabel = {
  SINGULAR: 'other',
  PLURAL: 'others',
};

export const TopButtonLabel = {
  SAVE: 'Save Pending Changes',
  VIEW: 'See Changes',
};

export const PendingChangesByUserMenuLabel = {
  SAVE_MINE: 'Save My Changes',
  CANCEL_MINE: 'Cancel My Changes',
  SAVE_SELECTED: "Save Selected Users' Changes",
  CANCEL_SELECTED: "Cancel Selected Users' Changes",
};

export const PendingChangesSaveDialogHeader = {
  MINE: 'Save your changes to the loan?',
  SELECTED: "Save the selected users' changes to the loan?",
};

export const PendingChangesCancelDialogDescription = {
  ALL: 'All changes will be canceled.',
  MINE: "Your pending changes will be canceled. Other people's pending changes stay pending.",
  SELECTED:
    "The selected users' pending changes will be canceled. Everyone else's pending changes stay pending.",
};
